'use client';

import { useEffect, useState } from 'react';
import { timeAgoShort } from '@/utils/helpers';

interface TimeAgoProps {
  date: string;
  className?: string;
  /** Tick every minute. Off by default; browse grids render dozens of these. */
  live?: boolean;
}

// The label is derived from now(), which the server and the browser evaluate at
// different instants, so it cannot be server-rendered without a hydration
// mismatch. Stay empty until mounted, then compute it on the client.
export function TimeAgo({ date, className, live = false }: TimeAgoProps) {
  const [timeString, setTimeString] = useState('');

  useEffect(() => {
    setTimeString(timeAgoShort(date));
    if (!live) return;

    const interval = setInterval(() => setTimeString(timeAgoShort(date)), 60000);
    return () => clearInterval(interval);
  }, [date, live]);

  // Non-breaking space keeps the line box, so the row holds its height before mount.
  return <span className={className}>{timeString || ' '}</span>;
}
